<ng-container *ngIf="node">
    <app-node *ngIf="node.id != 'cs_initializer'" ngClass="wf-diagram-{{direction}}"
      [id]="node.id"
      [screenName]="screenName"
      [parentNode]="parentNode"
      [name]="node.name"
      [parentId]="node.parentId"
      [model]="node.model"
      [children]="node.children"
      [key]="node.key"
      [hasParent]="hasParent"
      [blockId]="node.blockId"
      [block_name]="node.name"
      [isNew]="isNew"
      [dagSourceModel]="dagSourceModel"
      [index]="index"
      [condition]="node.condition"
      [direction]="direction">
    </app-node>

    <app-node-root *ngIf="node.id == 'cs_initializer'"
        [id]="node.id"
        [screenName]="screenName"
        [name]="node.name"
        [mainObjectName]="node.mainObjectName"
        [parentId]="node.parentId"
        [blockId]="node.blockId"
        [rules]="node.rules"
        [children]="node.children"
        [hasParent]="hasParent"
        [isNew]="isNew"
        [block_name]="node.name"
        [dagSourceModel]="dagSourceModel"
        [direction]="direction">
    </app-node-root>
</ng-container>

<div *ngIf="node?.children?.length" ngClass="wf-diagram-reports-{{direction}}" class="wf-diagram-reports">
    <ng-container *ngFor="let childNode of node?.children; first as isFirst; last as isLast; index as idx">
        <div ngClass="wf-diagram-container-{{direction}}" class="wf-diagram-container" [ngClass]="{'flex-end' : node?.children.length > 1}">
            <div ngClass="wf-diagram-connector-container-{{direction}}" class="wf-diagram-connector-container">
                <div
                    class="wf-diagram-connector wf-diagram-connector-border"
                    [ngClass]="{'wf-diagram-connector-start': isFirst}"
                    [style.border-color]="isFirst?'transparent':''"></div>
                <div
                    class="wf-diagram-connector-border"
                    [ngClass]="{'wf-diagram-connector-left': isFirst, 'wf-diagram-connector-right': isLast}"></div>
                <div
                    class="wf-diagram-connector wf-diagram-connector-border"
                    [ngClass]="{'wf-diagram-connector-last': isLast}"
                    [style.border-color]="isLast?'transparent':''"></div>
            </div>
            <app-node-view
                [parentNode]="node"
                [node]="childNode"
                [hasParent]="true"
                [isNew]="false"
                [index]="idx"
                [nodeOptions]="nodeOptions"
                [dagSourceModel]="dagSourceModel"
                [screenName]="screenName"
                [direction]="direction">
            </app-node-view>
        </div>
    </ng-container>
</div>


